  function toggleVideo(videoId, overlayId) {
    const video = document.getElementById(videoId);
    const overlay = document.getElementById(overlayId);

    if (video.paused) {
      document.querySelectorAll('video').forEach(v => {
        if (v.id !== videoId) {
          v.pause();
          document.getElementById(v.id === 'video1' ? 'overlay1' : 'overlay2').style.display = 'flex';
        }
      });
      video.play();
      overlay.style.display = 'none';
    } else {
      video.pause();
      overlay.style.display = 'flex';
    }

    video.addEventListener('ended', () => {
      overlay.style.display = 'flex';
    }, { once: true });
  }